import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import Content from "./Content"
import { getContent } from '../../functions/content'
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '1000px',
        "@media (max-width: 770px)": {
            width: "100%"
        },


    }
}));

const ListContent = () => {

    // console.log("ListContent")

    const styles = useStyles();

    const [content, setContent] = useState([{ _id: "", title: "", image_urls: [], content: "", date: "", author: "" }]);
    const [last, setLast] = useState(null);

    useEffect(() => {
        console.log("hi")
        getContent(last).then(res => {
            console.log(res)
            if (content[0]._id === "") {
                setContent(res);
            } else {
                setContent([...content, ...res])
            }

        })
    }, [last])

    const onScroll = () => {
        if (window.scrollY + document.documentElement.clientHeight > document.documentElement.scrollHeight - 1) {
            // dispatch(loadingScreen);
            setLast(content[content.length - 1]._id)
            console.log("onScroll")
        }
    };

    useEffect(() => {
        console.log("add scroll")
        window.addEventListener("scroll", onScroll);
        return () => {
            console.log("remove scroll")
            window.removeEventListener("scroll", onScroll);
        };
    });

    return (
        <>
            <div>
                <h2>
                    콘텐츠
                </h2>
            </div>
            <div className={styles.container}>

                {content.length === 1 ?
                    <CircularProgress />
                    :
                    <>
                        {content.map(item => {
                            return <Content key={item._id} date={moment(item.date).format("YYYY.MM.DD")} title={item.title} image_urls={item.image_urls} content={item.content} />
                        })}
                    </>
                }

            </div>
        </>
    );
};

export default ListContent;